import { BaseApiService } from '../../../shared/base-service/base-api.service';
import { MakeModelCreate } from '../../models/make-model-create.model';
import { Injectable } from '@angular/core';

@Injectable()
export class VehicleMakeModelService extends BaseApiService {

    getAllModelsTypes() {
        return this.get('vehicle/vehicle/GetAllVehicleTypes/');
    }

    createMakeModel = (create: MakeModelCreate) => this.post('Vehicle/Vehicle/MakeModel/Create', create);
}
